import { render, staticRenderFns } from "./PsotEditAbout.vue?vue&type=template&id=60a10904&scoped=true&"
import script from "./PsotEditAbout.vue?vue&type=script&lang=js&"
export * from "./PsotEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a10904",
  null
  
)

export default component.exports